<template>
  <div class="wrap" v-loading="loading">
    <div class="place">
      <router-link class="link" to="./">首页</router-link>
      <div class="division">/</div>
      <div class="active">退货单明细</div>
    </div>
    <div class="master" ref="master">
        <el-descriptions class="margin-top" title="单据信息" :column="2" size="medium">
          <template slot="extra">
            <el-button
              v-if="status == 'A'"
              type="primary"
              size="mini"
              @click="confirm()"
              >确认</el-button
            >
            <el-button type="primary" size="mini" @click="print()">打印</el-button>
          </template>
          <el-descriptions-item label="单号">{{ master.pro_code }}</el-descriptions-item>
          <el-descriptions-item label="日期">{{ master.pro_date }}</el-descriptions-item>
          <el-descriptions-item label="创建人">{{ master.CreateBy }}</el-descriptions-item>
          <el-descriptions-item label="创建时间">{{ master.CreateOn }}</el-descriptions-item>
          <el-descriptions-item label="审核人">{{ master.ApprovedBy }}</el-descriptions-item>
          <el-descriptions-item label="审核时间">{{ master.ApprovedOn }}</el-descriptions-item>
          <el-descriptions-item label="状态">{{ master.Status }}</el-descriptions-item>
        </el-descriptions>
    </div>
    <template>
      <el-table
        :data="tableData"
        :style="contentStyleObj"
        fit
        border
        show-summary
        :summary-method="getSummaries"
        @cell-click="openEditColumn"
      >
        <el-table-column type="index" width="50"> </el-table-column>
        <el-table-column prop="item_code" label="货品编码"> </el-table-column>
        <el-table-column prop="codeForSupp" label="工厂编码"> </el-table-column>
        <el-table-column prop="item_name_cn" label="中文名称"></el-table-column>
        <el-table-column prop="item_sn" label="序列号"></el-table-column>
        <el-table-column prop="carMod" label="车型"> </el-table-column>
        <el-table-column prop="pro_cause" label="退货原因"> </el-table-column>
        <el-table-column prop="item_qty" label="数量"> </el-table-column>
        <el-table-column prop="unit" label="单位"> </el-table-column>
        <el-table-column prop="supplier_remarks" label="差异备注">
          <template slot-scope="scope">
            <span v-show="!scope.row.Edit">{{scope.row.supplier_remarks}}</span>
            <el-input
              @blur="editColumnData(scope.row)"
              @keyup.enter.native="editColumnData(scope.row)"
              v-show="scope.row.Edit"
              size="mini"
              v-model="scope.row.supplier_remarks"
              :ref="'input'+scope.row.ROW_NUMBER"
            ></el-input>
          </template>
        </el-table-column>
      </el-table>
    </template>
  </div>
</template>
<script>
export default {
  name: "order_detail",
  props:['param'],
  data() {
    return {
      contentStyleObj: {
        height: "",
        "min-width": "1400px",
        overflow: "auto",
      },
      params: this.$route.params,
      tableData: [],
      status: "",
      master: [],
      loading: false,
      cell_style: {
        "text-align": "center",
      },
    };
  },
  async created() {
    this.loading = true;
    await this.getData();
    this.loading = false;
    this.tableData.forEach((item) => {
      item.Edit = false;
    });
  },
  mounted(){
    this.getHeight();
  },
  methods: {
    async getData() {
      // let params = this.params;
      let params = JSON.parse(this.param);
      let res = await this.$Http.getProDetail(params);
      if (res.code == 0) {
        res.data.data.forEach((item) =>{
          item.Edit = false;
          this.tableData.push(item);
        })
        this.status = res.data.status;
        this.master = res.data.master;
      } else {
        this.$message.error(res.msg);
      }
    },
    //设置窗口高度
    getHeight() {
      this.contentStyleObj.height = window.innerHeight - 120 - 70 -15 - this.$refs.master.offsetHeight + "px";
    },
    /**
     * 确认
     */
    confirm() {
      this.$confirm("是否确认退货单？", "确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          // let params = this.params;
          let params = JSON.parse(this.param);
          let res = await this.$Http.proConfirm(params);
          if (res.code == 0) {
            this.$message({
              message: "确认成功",
              type: "success",
            });
            this.getData();
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(() => {});
    },
    /**
     * 打印
     */
    print() {
      let params = JSON.parse(this.param);
      let url =
        this.GLOBAL.basic_url +
        "sr_scm/printPro?dept_id=" +
        params.dept_id +
        "&pro_code=" +
        params.pro_code;
      window.open(url);
    },
    //合计方法
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        sums[index] = "";
        if (column.property == "item_name_cn") {
          sums[index] = "运费:";
        }
        if (column.property == "item_sn") {
          sums[index] = this.master.fee;
        }
        if (column.property == "item_qty") {
          const values = data.map((item) => Number(item[column.property]));
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        }
      });
      return sums;
    },
    // 打开信息编辑
    openEditColumn(row, column) {
      if(this.status!='A'){
        return 
      }
      if (column.property === "supplier_remarks") {
        let refName='';
        this.tableData.forEach((item,index) => {
          if (item.ROW_NUMBER === row.ROW_NUMBER) {
            row.Edit = true;
            // 激活当前点击的单元格进入可以编辑（span与el-input标签显示隐藏切换）
            this.$set(this.tableData,index,row);
            refName = 'input'+row.ROW_NUMBER;
            // this.$refs['input'+row.ROW_NUMBER].focus();
          }
        });
        setTimeout(()=>{
          this.$refs[refName].focus();
        },1)
      }
    },
    // 表格数据编辑保存并关闭编辑
    async editColumnData(row) {
      // 关闭表格编辑
      this.tableData.forEach((item,index) => {
        if (item.ROW_NUMBER === row.ROW_NUMBER) {
            row.Edit = false;
            this.$set(this.tableData,index,row);
        }
      });
      let param = JSON.parse(this.param);
      let params = {
        dept_id: param.dept_id,
        pro_code: param.pro_code,
        seq_no: row.seq_no,
        supplier_remarks: row.supplier_remarks
      }
      // let res = await this.$Http.updateSupplier_remarks(params);
      await this.$Http.updateSupplier_remarks(params);
    },
  },
};
</script>

<style scoped>
.wrap {
  padding: 0 20px;
  width: 100%;
  height: 100%;
  background-color: #fff;
  box-sizing: border-box;
  text-align: center;
}
.place {
  height: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.division {
  padding: 0 5px;
  color: #c0c4cc;
}
.btn {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 15px 0;
}
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
  text-align: left;
}
.el-table::before{
  height: 0 !important;
}
</style>